import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { BackgroundImage } from "../../elements";
import { mobileIs } from "../../utils/siteUtils";
import "./style.scss";
import { gtag } from "../../utils";
import Swiper from 'swiper';
import moment from 'moment-timezone';
let i = 0;
const TopNews = props => {
	const { lang, rendering, fields, page } = props;
  const { items } = fields;
  const isMobile = mobileIs()
  const swiperEl = useRef(null)
  const swiper = useRef(null)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [list, setList] = useState([])
  const timer = useRef()

  const buildSwiper = () => {
    swiper.current = new Swiper(swiperEl.current, {
      loop: true,
      watchSlidesProgress: true,
      slidesPerView: isMobile ? 1 : 'auto',
      observer: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {
        slideChangeTransitionStart(swiper) {
          let realIndex = swiper.realIndex
          setCurrentIndex(realIndex)
        }
      }
    })
  }

  const autoplay = () => {
    timer.current = setInterval(v => {
      if(i < items.length - 1) {
        i++
      } else {
        i=0
      }
      setCurrentIndex(i)
    }, 5000)
  }

  const changeNews = (e, index) => {
    i = index
    setCurrentIndex(index)
    clearInterval(timer.current) // 鼠标移上去停止自动轮播
  }

  const mouseLeave = () => {
    autoplay()
  }

  const goLink = (e, index) => {
    gtag('event', 'Component_info', {
      'component_name': 'TopNews',
      'page_title': page?.name
    });
    let a = document.createElement('a')
    a.setAttribute('href', items[index]?.fields?.itemDataSource?.fields?.pagePath?.value?.href)
    document.body.appendChild(a)
    a.click()
  }

  useEffect(() => {
    autoplay()
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth;
    let max = 0;
    let min = 0;
    if (pageWidth > 1200 && pageWidth < 1301) {
      min = 45;
      max = 60;
    } else if (pageWidth > 1300 && pageWidth < 1910 ) {
      min = 55;
      max = 70;
    } else if (pageWidth > 1910){
      min = 65;
      max = 80;
    }
    items.map((item) => {
      let title = item?.fields?.itemDataSource?.fields?.pc_title
      let arr = title?.value?.split(' ')
      let init = 0
      let initIndex = null
      let initTitle = ''
      if(title?.value?.length > min) {
        arr.map((word, index) => {
          init += (word.length + 1)
          console.log(init)
          if(init > min && init < max) {
            initIndex = index
          }
        })
        if(initIndex) {
          arr.map((word, index) => {
            if(index < initIndex + 1) {
              initTitle += (word + ' ')
            }
          })
          item.pc_title = {
            value: arr.length - 1 > initIndex ? initTitle + '<span> ...</span>' : initTitle
          }
        }
      } else {
        item.pc_title = item?.fields?.itemDataSource?.fields?.pc_title
      }
    })

    setList(items)

    let timer = setTimeout(v => {
      if(isMobile) {
        buildSwiper()
      }
      clearTimeout(timer)
    }, 100)
  }, [])

  const rootClasses = classNames("c-top-news", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
      <div className="c-top-news__swiper" ref={swiperEl}>
        <div className="swiper-wrapper">
          {items && items.map((item, index) => (
            <div className="swiper-slide" key={index} onClick={(e) => goLink(e, index)}>
              <BackgroundImage {...(item?.fields?.itemDataSource?.fields?.image)} className="image" />
              {!isMobile && <RichText tag="div" className="title" field={item?.fields?.itemDataSource?.fields?.pc_title} />}
              {isMobile && <RichText tag="div" className="title" field={item?.fields?.itemDataSource?.fields?.m_title} /> }
              <div className="date">{ !item?.fields?.itemDataSource?.fields?.showDate?.value ? (moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('LL')).split(' ')[0] + ', ' + moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('YYYY') : moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('LL') }</div>
            </div>
          ))}
        </div>
        <div className="swiper-pagination"></div>
      </div>
      <div className="c-top-news__content">
        <div className="c-top-news__content__swiper">
          <div className="swiper-wrapper">
            {items && items.map((item, index) => (
              <div className={["swiper-slide", index === currentIndex ? 'active' : ''].join(' ')} key={index} onClick={(e) => goLink(e, index)}>
                <BackgroundImage {...(item?.fields?.itemDataSource?.fields?.image)} className="image" />
                <div className="title-and-date">
                  {!isMobile && <RichText tag="div" className="title" field={item?.fields?.itemDataSource?.fields?.pc_title} />}
                  {isMobile && <RichText tag="div" className="title" field={item?.fields?.itemDataSource?.fields?.m_title} />}
                  <div className="date">{ !item?.fields?.itemDataSource?.fields?.showDate?.value ? (moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('LL')).split(' ')[0] + ', ' + moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('YYYY') : moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('LL') }</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="c-top-news__content__title">
          <div className="swiper-wrapper">
            {list && list.map((item, index) => (
              <div className={["swiper-slide", currentIndex === index ? 'active' : ''].join(' ')} key={index} onMouseOver={(e) => changeNews(e, index)} onMouseLeave={mouseLeave}>
                {!isMobile && <RichText tag="div" className="title" field={item?.pc_title} />}
                {isMobile && <RichText tag="div" className="title" field={item?.fields?.itemDataSource?.fields?.m_title} />}
                <div className="date">{ !item?.fields?.itemDataSource?.fields?.showDate?.value ? (moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('LL')).split(' ')[0] + ', ' + moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('YYYY') : moment(item?.fields?.itemDataSource?.fields?.publishdate?.value).format('LL') }</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default 	TopNews;